import React from 'react';
import Dialogue from 'components/UI/Dialogue/Dialogue';

const ClosePostDialogue = (props) => (
  <Dialogue
    subject={props.newPost || props.isGift ? 'Save a Draft?' : 'Update?'}
    message={
      props.isGift
        ? 'Do you want to save this gifted post as a draft? If so you can find it in Drafts.'
        : props.newPost
        ? 'Do you want to save this Post as a Draft? If so, you can find it in Drafts.'
        : 'Would you like to save the changes to this post?'
    }
    confirm={props.clicked}
    cancelled={props.cancelled}
    cancelText={props.newPost ? "Don't Save" : "Don't Update"}
    confirmationText={props.newPost ? 'Save' : 'Update'}
    postForm
  />
);

export default ClosePostDialogue;
